<div class="container-fluid">
  <div class="row g-3">
    <div class="col-xl-5">
      <div class="card position-relative h-100">
        @if (isLoading) {
          <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
        }
        <div class="card-header d-flex align-items-center gap-2">
          <h3 class="card-title mb-0">{{ isUpdate ? 'Edit Regulator' : 'Create Regulator' }}</h3>
          @if (regulator) {
            <span class="badge bg-primary-subtle text-primary text-uppercase regulator-code-badge">{{ regulator.code }}</span>
          }
        </div>
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="submitForm()">
            <div class="mb-3">
              <input-field type="text" label="Code" placeholder="Code" [inputFormControl]="control('code')" [readonly]="!canModify" />
            </div>
            <div class="mb-3">
              <input-field type="text" label="Name" placeholder="Name" [inputFormControl]="control('name')" [readonly]="!canModify" />
            </div>
            <div class="mb-1">
              <input-field type="text" label="External Code" placeholder="e.g. ng" [inputFormControl]="control('externalCode')" [readonly]="!canModify" />
            </div>
            <small class="text-muted">Identifier of the regulator on the Compliance Scan service. Scans can only be started when it is set.</small>

            <div class="d-flex justify-content-center gap-3 mt-4">
              <button type="button" class="btn btn-secondary px-4 py-2" (click)="goBack()">Cancel</button>
              @if (canModify) {
                <button type="submit" class="btn btn-success px-4 py-2" [disabled]="isLoading">Save</button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>

    @if (isUpdate) {
      <div class="col-xl-7">
        <div class="card position-relative h-100">
          @if (isLoadingChecks || isSyncingChecks) {
            <loader [config]="{ type: 'spinner', overlay: true, size: 'md' }"></loader>
          }
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title mb-0">Rules</h3>
            @if (canModify) {
              <button type="button" class="btn btn-sm btn-primary" (click)="syncChecks()" [disabled]="isSyncingChecks">
                <i class="fa fa-sync me-1"></i>Sync rules
              </button>
            }
          </div>
          <div class="card-body">
            @if (checks.length === 0) {
              <p class="text-muted mb-0">
                No rules imported yet.
                @if (canModify) { Use "Sync rules" to import them from the Compliance Scan service. }
              </p>
            } @else {
              <div class="table-responsive">
                <table class="table table-sm align-middle mb-0 regulator-checks-table">
                  <thead>
                    <tr>
                      <th style="width: 50px">#</th>
                      <th>Name</th>
                      <th>Key</th>
                      <th>Regulation</th>
                      <th>Rule</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (check of checks; track check.checkId) {
                      <tr>
                        <td>{{ check.position ?? '-' }}</td>
                        <td class="fw-semibold">{{ check.name }}</td>
                        <td><code>{{ check.key }}</code></td>
                        <td>{{ check.regulation || '-' }}</td>
                        <td class="regulator-check-rule">{{ check.rule || '-' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
